// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DropModalMetadataQueryVariables = Types.Exact<{
  entityId: Types.Scalars['ID']['input'];
  skipProject: Types.Scalars['Boolean']['input'];
  skipDevelopment: Types.Scalars['Boolean']['input'];
}>;


export type DropModalMetadataQuery = { __typename?: 'Query', costCodes: Array<{ __typename?: 'CostCode', id: string, displayName: string }>, locations: Array<{ __typename?: 'Location', id: string, name: string, locations: Array<{ __typename?: 'Location', id: string, name: string, locations: Array<{ __typename?: 'Location', id: string, name: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType } }>, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType } }>, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType } }>, globalPlanTasks: { __typename?: 'GlobalPlanTasksPageResult', entities: Array<{ __typename?: 'GlobalPlanTask', nameForEntity: string, id: string, name: string }> }, project?: { __typename?: 'StandaloneProject', id: string, market: { __typename?: 'Market', id: string } } | { __typename?: 'Region', id: string, market?: { __typename?: 'Market', id: string } | null | undefined } | { __typename?: 'Market', id: string, market: { __typename?: 'Market', id: string } } | { __typename?: 'Community', id: string, costCodesWithDraws: Array<{ __typename?: 'CostCode', id: string, name: string }>, market: { __typename?: 'Market', id: string } } | { __typename?: 'Subdivision', id: string, market: { __typename?: 'Market', id: string } } | { __typename?: 'Lot', id: string, market: { __typename?: 'Market', id: string } } | { __typename?: 'Structure', id: string, market: { __typename?: 'Market', id: string } } | { __typename?: 'Unit', id: string, market: { __typename?: 'Market', id: string } }, development?: { __typename?: 'Development', id: string, market: { __typename?: 'Market', id: string }, costCodesWithDraws: Array<{ __typename?: 'CostCode', id: string, name: string }> } };

export type DropLocationTreeFragment = { __typename?: 'Location', id: string, name: string, locations: Array<{ __typename?: 'Location', id: string, name: string, locations: Array<{ __typename?: 'Location', id: string, name: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType } }>, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType } }>, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType } };

export type DropLocationFragment = { __typename?: 'Location', id: string, name: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType } };

export type SaveDropMutationVariables = Types.Exact<{
  input: Types.SaveDropInput;
}>;


export type SaveDropMutation = { __typename?: 'Mutation', saveDrop: { __typename?: 'SaveDropResult', drop: { __typename?: 'Drop', id: string } } };

export const DropLocationFragmentDoc = gql`
    fragment DropLocation on Location {
  ...Named
  type {
    code
  }
}
    ${NamedFragmentDoc}`;
export const DropLocationTreeFragmentDoc = gql`
    fragment DropLocationTree on Location {
  ...DropLocation
  locations {
    ...DropLocation
    locations {
      ...DropLocation
    }
  }
}
    ${DropLocationFragmentDoc}`;
export const DropModalMetadataDocument = gql`
    query DropModalMetadata($entityId: ID!, $skipProject: Boolean!, $skipDevelopment: Boolean!) {
  costCodes(filter: {version: 2}) {
    id
    displayName
  }
  locations(filter: {version: 2, type: [GROUP]}) {
    ...DropLocationTree
  }
  globalPlanTasks {
    entities {
      ...Named
      nameForEntity(entityId: $entityId)
    }
  }
  project(id: $entityId) @skip(if: $skipProject) {
    id
    market {
      id
    }
    ... on Community {
      id
      costCodesWithDraws {
        ...Named
      }
    }
  }
  development(id: $entityId) @skip(if: $skipDevelopment) {
    id
    market {
      id
    }
    costCodesWithDraws {
      ...Named
    }
  }
}
    ${DropLocationTreeFragmentDoc}
${NamedFragmentDoc}`;

/**
 * __useDropModalMetadataQuery__
 *
 * To run a query within a React component, call `useDropModalMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDropModalMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDropModalMetadataQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      skipProject: // value for 'skipProject'
 *      skipDevelopment: // value for 'skipDevelopment'
 *   },
 * });
 */
export function useDropModalMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DropModalMetadataQuery, DropModalMetadataQueryVariables> & ({ variables: DropModalMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DropModalMetadataQuery, DropModalMetadataQueryVariables>(DropModalMetadataDocument, options);
      }
export function useDropModalMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DropModalMetadataQuery, DropModalMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DropModalMetadataQuery, DropModalMetadataQueryVariables>(DropModalMetadataDocument, options);
        }
export function useDropModalMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DropModalMetadataQuery, DropModalMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DropModalMetadataQuery, DropModalMetadataQueryVariables>(DropModalMetadataDocument, options);
        }
export type DropModalMetadataQueryHookResult = ReturnType<typeof useDropModalMetadataQuery>;
export type DropModalMetadataLazyQueryHookResult = ReturnType<typeof useDropModalMetadataLazyQuery>;
export type DropModalMetadataSuspenseQueryHookResult = ReturnType<typeof useDropModalMetadataSuspenseQuery>;
export type DropModalMetadataQueryResult = Apollo.QueryResult<DropModalMetadataQuery, DropModalMetadataQueryVariables>;
export const SaveDropDocument = gql`
    mutation SaveDrop($input: SaveDropInput!) {
  saveDrop(input: $input) {
    drop {
      id
    }
  }
}
    `;
export type SaveDropMutationFn = Apollo.MutationFunction<SaveDropMutation, SaveDropMutationVariables>;

/**
 * __useSaveDropMutation__
 *
 * To run a mutation, you first call `useSaveDropMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDropMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDropMutation, { data, loading, error }] = useSaveDropMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDropMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveDropMutation, SaveDropMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveDropMutation, SaveDropMutationVariables>(SaveDropDocument, options);
      }
export type SaveDropMutationHookResult = ReturnType<typeof useSaveDropMutation>;
export type SaveDropMutationResult = Apollo.MutationResult<SaveDropMutation>;
export type SaveDropMutationOptions = Apollo.BaseMutationOptions<SaveDropMutation, SaveDropMutationVariables>;